/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_CenterInputs */

const vi_shop_home_pos_center = /** @type {(inputs: Shop_Home_Pos_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữa`)
};

/**

* @param {Shop_Home_Pos_CenterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_center = /** @type {((inputs?: Shop_Home_Pos_CenterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_CenterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_center(inputs)
});